// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"ecdcb7d8","129":"b206a06d","159":"15bb2149","330":"020249ef","614":"b475d9b0","757":"ffcc1437","910":"684c7c57","967":"51542012"}[chunkId] + ".chunk.js";
};